import React from 'react';
import { TweenMax } from 'gsap';

export default {

    animateIn(AppContainer) {
        setTimeout(() => {
            TweenMax.to(AppContainer, 1, {opacity: 1});
        }, 250);
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/layout/App/animations.js